import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import useStyles from './sampleDevelopmentNl.style';
import {
  CheckBoxFastField,
  TextFieldFastField,
  UnitOfQuantitiesFastField,
  UnitOfMeasurementsFastField,
} from '../../../components';

interface SampleDevelopmentNlPackingProductProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlPackingProduct: React.FC<SampleDevelopmentNlPackingProductProps> = (
  props,
) => {
  const { isCrtLocked = false } = props;
  const classes = useStyles();

  return (
    <Grid container spacing={1} direction="row" justifyContent="flex-start">
      <Typography className={classes.title}>Product Packing</Typography>
      <Grid item xs={12}>
        <Grid
          container
          spacing={1}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs={12} sm={2}>
            <CheckBoxFastField
              disabled={isCrtLocked}
              name="prodPackingRoll"
              label="Roll"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <CheckBoxFastField disabled={isCrtLocked} name="prodPackingCut" label="Cut" />
          </Grid>
          <Grid item xs={12} sm={2}>
            <CheckBoxFastField
              disabled={isCrtLocked}
              name="prodPackingSheet"
              label="Sheet"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <CheckBoxFastField
              disabled={isCrtLocked}
              name="prodPackingFold"
              label="Fold"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <CheckBoxFastField
              disabled={isCrtLocked}
              name="prodPackingContinuous"
              label="Continuous"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          spacing={1}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs={12} sm={3}>
            <TextFieldFastField
              disabled={isCrtLocked}
              type="number"
              step="any"
              name="labelPerRoll"
              label="Label Per Roll"
              variant="outlined"
              margin="dense"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <UnitOfQuantitiesFastField
              disabled={isCrtLocked}
              name="labelPerRollUnit"
              label="Unit"
              margin="dense"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextFieldFastField
              disabled={isCrtLocked}
              type="number"
              step="any"
              name="maxRollDiameter"
              label="Max Roll Diameter"
              variant="outlined"
              margin="dense"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <UnitOfMeasurementsFastField
              disabled={isCrtLocked}
              name="maxRollDiameterUnit"
              label="Unit"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextFieldFastField
              disabled={isCrtLocked}
              type="number"
              step="any"
              name="coreDiameter"
              label="Core Diameter"
              variant="outlined"
              margin="dense"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <UnitOfMeasurementsFastField
              disabled={isCrtLocked}
              name="coreDiameterUnit"
              label="Unit"
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs={12} sm={2}>
            <CheckBoxFastField
              disabled={isCrtLocked}
              name="maxSplice"
              label="Max Splice"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextFieldFastField
              disabled={isCrtLocked}
              name="maxSpliceData"
              label="Max Splice"
              variant="outlined"
              margin="dense"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <CheckBoxFastField
              disabled={isCrtLocked}
              name="spliceRequire"
              label="Splice Requirement"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextFieldFastField
              disabled={isCrtLocked}
              name="spliceRequireData"
              label="Splice Requirement"
              variant="outlined"
              margin="dense"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <CheckBoxFastField
              disabled={isCrtLocked}
              name="spliceTape"
              label="Splice Tape Color/Width(mm)"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextFieldFastField
              disabled={isCrtLocked}
              name="spliceTapeData"
              label="Splice Tape Color/Width(mm)"
              variant="outlined"
              margin="dense"
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SampleDevelopmentNlPackingProduct;
